<template>
  <div class="w-100 p-4">
    <filter-form ref="filterFormRef" @ensure="init" @threshold-submited="init" />

    <div v-show="filterForm.chartType == 'bar'" class="flex-wrap chart-wrap">
      <div v-for="field of showField" :key="field" class="w-50">
        <div :id="`bar-${field}`" style="height: 500px;"></div>

        <!-- <div class="text-center">
          <el-button type="primary" size="mini" @click="toSubPage({grade: '1', field})">合规资源详情</el-button>
          <el-button type="primary" size="mini" @click="toSubPage({grade: '2', field})">不合规资源详情</el-button>
          <el-button type="primary" size="mini" @click="toSubPage({grade: '3', field})">严重不合规资源详情</el-button>
        </div> -->
      </div>
    </div>

    <div v-show="filterForm.chartType == 'pie'" class="flex-wrap mt-4 chart-wrap">
      <div v-for="field of showField" :key="field" class="w-25">
        <div :id="`pie-${field}`" style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {ref, provide, onMounted, nextTick} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import * as echarts from "echarts";
import FilterForm from './filter-form.vue'

async function sleep(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
}

function useBar(showField, allCharts, toSubPage) {
  let thresholdData = ref({})

  function toNumArr(str) {
    return str.split("-").map((item) => Number(item));
  }

  function getThreshold(field) {
    const data = thresholdData.value[field]?.Threshold
    return data ? data : [0, 0]
  }

  async function fetchThresholdData(project, formData) { //获取阈值数据
    const {data} = await axios('memory/static_resource_threshold/', {
        params: {
          project,
          allType: formData.AssetType,
        }
      })

    thresholdData.value = data
  }

  function getBarInfo(rangeStart, thresholdNon, thresholdSerious) {
    let barColor = '',
      type = ''

    if ((thresholdNon == 0 && thresholdSerious == 0) || rangeStart < thresholdNon) {
      barColor = 'rgb(145, 204, 117)'
      type = '合规'
    } else if (rangeStart < thresholdSerious) {
      barColor = 'rgb(250, 200, 88)'
      type = '不合规'
    } else {
      barColor = 'rgb(238, 102, 102)'
      type = '严重不合规'
    }

    return {barColor, type}
  }

  function addClickEvent(chart, field) {
    chart.on('click', function (params) { //params包含了点击的图表的相关信息
      toSubPage({
        range: [params.data.rangeStart, params.data.rangeEnd],
        field
      })
    })
  }

  async function renderBar({field, chartData = {}} = {}) {
    let chart = allCharts.value[`bar-${field}`]?.chart

    if (chart) chart.dispose()
    await nextTick()
    await sleep(600);
    const chartDom = document.getElementById(`bar-${field}`);
    chart = echarts.init(chartDom);

    const keys = Object.keys(chartData);
    let option = null
    let result = { chart, field }

    if (!keys.length) {
      //chart.clear();
      //allCharts[`bar-${quality}-${field}`] = { chart, field };
      option = {
        title: {
          text: `${field}分布展示图`,
          left: "center",
          bottom: 20
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [],
            type: "bar",
          }
        ],
        dataZoom: [
          { type: "slider" }
        ]
      }
      result.empty = true
    } else {
      const threshold = getThreshold(field),
        //dataZoomEnd = Math.min(100 / (keys.length / 10), 100),
        lastDataKey = toNumArr(keys[keys.length - 1]),
        max = lastDataKey[1] + 1,
        interval = max - lastDataKey[0], //区间大小
        halfInterval = interval / 2,
        thresholdNon = interval == 1 ? threshold[0] + 1 : threshold[0],
        thresholdSerious = interval == 1 ? threshold[1] + 1 : threshold[1],
        totalNum = Object.values(chartData).reduce((total, num) => total + num, 0), //所有区间的总数量
        seriesData = Object.entries(chartData).map((item) => {
          const range = toNumArr(item[0]),
            rangeStart = range[0],
            //middle = interval == 1 ? rangeStart : rangeStart + halfInterval,
            middle = rangeStart + halfInterval,
            {barColor, type} = getBarInfo(rangeStart, thresholdNon, thresholdSerious); //区间中点x坐标
          
          return {value: [middle, item[1]], itemStyle: {color: barColor}, rangeStart, rangeEnd: range[1], type, totalNum};
        });

      option = getBarOption(field, interval, max, seriesData, thresholdNon, thresholdSerious)
    }

    chart.setOption(option, {notMerge: true});
    addClickEvent(chart, field)
    result.option = option;
    allCharts.value[`bar-${field}`] = result;
  }

  async function renderAllBar(project, formData) {
    await fetchThresholdData(project, formData)
    const {data} = await axios('memory/one_level_tree_static/', {
      params: {
        project,
        static_type: formData.AssetType,
        version: formData.Versions,
        scan_time: formData.ScanTime,
        fields: formData.showField.join(','),
        isComplete: formData.isComplete,
      }
    })

    showField.value = Object.keys(data)
    showField.value.forEach(field => renderBar({field, chartData: data[field]}))
  }

  function getBarOption(field, xMinInterval, xMax, seriesData, thresholdNon, thresholdSerious) {
    return {
      title: {
        text: `${field}分布展示图`,
        left: "center",
        bottom: 20
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (value) => {
          const {rangeStart, rangeEnd, value: val, itemStyle, type, totalNum} = value[0].data
          const rate = ((val[1] / totalNum) * 100).toFixed(1) + '%'
          
          return `区间：${rangeStart}-${rangeEnd} <br/>数量：${val[1]} <br/>占比：${rate} <br/>
            <span style="display: inline-block;width: 8px;height: 8px;border-radius: 100%;background: ${itemStyle.color};margin: 0 2px 1px 0;"></span>
            <span>${type}</span>
          `
        }
      },
      xAxis: {
        type: "value",
        min: 0,
        max: xMax,
        minInterval: xMinInterval,
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          data: seriesData,
          type: "bar",
          // barMinWidth: 50,
          barCategoryGap: "0%",
          markLine: {
            symbol: "none",
            data: [
              {
                xAxis: thresholdNon,
                label: { formatter: "超标" }
              },
              {
                xAxis: thresholdSerious,
                label: { formatter: "严重超标" }
              }
            ]
          }
        }
      ],
      //itemStyle: {color: 'yellow'},
      dataZoom: [
        { type: "slider", filterMode: "empty", start: 0 }
      ]
    }
  }

  return {renderAllBar}
}

function usePie(showField, allCharts, toSubPage) {
  function addClickEvent(chart, field) {
    chart.on('click', function(params) { //params包含了点击的图表的相关信息
      const gradeConfig = {
        '合规': '1',
        '不合规': '2',
        '严重不合规': '3',
      }

      toSubPage({
        grade: gradeConfig[params.name],
        field
      })
    })
  }

  function getPieOption(field, qualifiedNum, noQualifiedNum, seriousNum) {
    return {
      title: {
        text: `${field}分布展示图`,
        left: "center",
        bottom: 20
      },
      tooltip: {
        trigger: "item"
      },
      legend: {
        top: "5%",
        left: "center"
      },
      color: ['rgb(145, 204, 117)', 'rgb(250, 200, 88)', 'rgb(238, 102, 102)'],
      series: [
        {
          //name: "所有资源子类型的部件类型分布展示图",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2
          },
          label: {
            position: 'inner',
            formatter: '{d}%',
            fontSize: 20,
            fontWeight: 'bold',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: "bold",
              formatter: '{d}%'
            }
          },
          data: [
            { value: qualifiedNum, name: "合规" },
            { value: noQualifiedNum, name: "不合规" },
            { value: seriousNum, name: "严重不合规" }
          ]
        }
      ]
    }
  }

  function renderPie({field, chartData} = {}) {
    const qualifiedNum = chartData.Num,
      noQualifiedNum = chartData.Non_Num,
      seriousNum = chartData.Serious_Num,
      option = getPieOption(field, qualifiedNum, noQualifiedNum, seriousNum)

    const chartDom = document.getElementById(`pie-${field}`);
    const chart = echarts.init(chartDom);
    chart.setOption(option);
    //addClickEvent(chart, field);
    allCharts.value[`pie-${field}`] = {chart, option, field};
  }

  async function renderAllPie(project, formData) {
    const {data} = await axios('memory/one_level_static/', {
      params: {
        project,
        static_type: formData.AssetType,
        version: formData.Versions,
        scan_time: formData.ScanTime,
        fields: formData.showField.join(','),
        isComplete: formData.isComplete,
      }
    })

    showField.value = Object.keys(data)
    await nextTick()
    showField.value.forEach(field => renderPie({field, chartData: data[field]}))
  }

  return {renderAllPie}
}

export default {
  components: {FilterForm},

  setup() {
    const filterFormRef = ref(null),
      route = useRoute(),
      router = useRouter(),
      showField = ref([]),
      filterForm = ref({}),
      project = route.query.project,
      allCharts = ref({}),
      {renderAllBar} = useBar(showField, allCharts, toSubPage),
      {renderAllPie} = usePie(showField, allCharts, toSubPage)

    function toSubPage({grade, field, range} = {}) {
      const {Versions, ScanTime, AssetType} = filterForm.value
      const params = encodeURIComponent(JSON.stringify({
          Versions,
          ScanTime,
          AssetType,
          showField: field,
          grade,
          range,
        }))

      const link = router.resolve({
        name: 'ResourceScanSubBase',
        query: {params}
      })

      window.open(link.href, '_blank')
    }

    async function init(formData) {
      filterForm.value = JSON.parse(JSON.stringify(formData))

      if (filterForm.value.chartType == 'bar') {
        renderAllBar(project, formData)
      } else {
        renderAllPie(project, formData)
      }
    }

    onMounted(async() => {
      const {formData} = await filterFormRef.value.getFilterOptions()
      init(formData)
    })

    return {
      filterForm,
      showField,
      filterFormRef,
      init,
      toSubPage
    }
  }
}
</script>

<style scoped>
.chart-wrap {
  display: flex;
}
</style>